import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { setCurrentProduct, setGlobalLoading, setUserCart, } from "Root/profile/redux/actionCreators/makeActionCreator";
import LoadCurrentProductThunk from "Root/profile/redux/thunkCreators/products/currentProduct";
import utils from "Root/profile/utils";
import additionalFlavorSticks from "Images/profile/flavor_boosts.png";
import { AddUserCartItemThunk, LoadUserCartThunk, } from "Root/profile/redux/thunkCreators/products/userCart";
import { useTracking } from "react-tracking";
import { EditProduct } from "Root/profile/utils/trackingEnums";
import { hydrateValuesFromSku } from "../../BYBFlow/PDP/data";
import httpService from "Root/api/httpService";
import { LoadPricingThunk } from "Root/profile/redux/thunkCreators/orders/pricing";
const defaultProductData = {
    attribute_toggles: [],
    flavors: [],
    how_to_use: [],
    bags_info: [],
    icons: [],
    image: "",
    ingredient_string: "",
    ingredients: [],
    mixes_well_with: [],
    name: "",
    nutrition_facts: "",
    product_info: [],
    product_title: "",
    reason_why: "",
    short_name: "",
    when_to_take: [],
};
const useEditYourBox = (itemType = null) => {
    const reduxUserCart = useSelector((state) => state.userCart);
    const isByb = useSelector((state) => state.user.user_class === "byb");
    const [openBybDrawer, setOpenBybDrawer] = useState(false);
    const [currentBYBProduct, setCurrentBybProduct] = useState("");
    const [editBybMode, setEditBybMode] = useState(false);
    const originalUserCart = useSelector((state) => state.originalUserCart);
    const [isAddProduct, setIsAddProduct] = useState(false);
    const [isMoreDetails, setIsMoreDetails] = useState(false);
    const [alreadyOpenedDrawer, setAlreadyOpenedDrawer] = useState(false);
    const history = useHistory();
    const { hash, pathname } = useLocation();
    const missingAddons = useSelector((state) => state.missingAddons);
    const currentProduct = useSelector((state) => state.currentProduct);
    const userCart = useSelector((state) => state.userCart);
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const [forceFlavor, setForceFlavor] = useState(false);
    const { trackEvent } = useTracking();
    const trackEditProduct = (product) => {
        trackEvent({
            funComponent: EditProduct.edit_product,
            event: `${EditProduct.edit_product}__product_name=${product}`,
        });
    };
    const trackDeleteItem = (product) => {
        trackEvent({
            funComponent: EditProduct.edit_product,
            event: `${EditProduct.Delete_product}__product_name=${product}`,
        });
    };
    const trackAddItem = (product) => {
        trackEvent({
            funComponent: EditProduct.edit_product,
            event: `${EditProduct.Add_product}__product_name=${product}`,
        });
    };
    const openDrawer = (product, moreDetail) => {
        if (isByb) {
            openEditDrawerBYB(product);
            return;
        }
        if (moreDetail) {
            setIsMoreDetails(true);
            trackEditProduct(product);
            dispatch(LoadCurrentProductThunk(product));
            setIsOpen(true);
        }
        else {
            setIsMoreDetails(false);
            trackEditProduct(product);
            dispatch(LoadCurrentProductThunk(product));
            setIsOpen(true);
        }
    };
    const getIsProductIsInCart = (product) => !!reduxUserCart.find((item) => item.item_type === product);
    const addProductOpenDrawer = (product, moreDetail) => {
        if (utils.isAdditionalItem(product) && !utils.isFlavorBoost(product)) {
            trackAddItem(product);
            dispatch(AddUserCartItemThunk(product));
            return;
        }
        if (isByb) {
            toggleBybDrawer(true)();
            setCurrentBybProduct(product);
            return;
        }
        setIsMoreDetails(!!moreDetail);
        setIsAddProduct(true);
        dispatch(LoadCurrentProductThunk(product));
        setIsOpen(true);
    };
    const onSubmit = () => {
        setIsOpen(false);
        setIsAddProduct(false);
        setIsMoreDetails(false);
        dispatch(setCurrentProduct(defaultProductData));
    };
    const toggleDrawer = (value) => () => {
        if (!value) {
            dispatch(setCurrentProduct(defaultProductData));
            dispatch(setUserCart(originalUserCart));
            setIsAddProduct(false);
            setIsMoreDetails(false);
            const path = pathname.split("#");
            path.slice(pathname.indexOf("#"));
            history.replace(path.join(""));
        }
        setIsOpen(value);
    };
    const openEditDrawerBYB = (product) => {
        setCurrentBybProduct(product);
        setEditBybMode(true);
        toggleBybDrawer(true)();
    };
    const toggleBybDrawer = (value) => () => {
        if (!value) {
            setCurrentBybProduct("");
            setEditBybMode(false);
        }
        setOpenBybDrawer(value);
    };
    const findCurrentQuantity = (short_name) => {
        if (typeof short_name !== "undefined") {
            if (isAddProduct) {
                const item = missingAddons.find((cartItem) => cartItem.product_key === short_name);
                return item?.quantity || 0;
            }
            const item = reduxUserCart.find((cartItem) => cartItem.item_type === short_name);
            return item?.quantity || 0;
        }
        return 0;
    };
    const getSelectedCurrentProduct = (productType) => {
        const product = productType && !isAddProduct
            ? reduxUserCart.find((item) => item.title === productType ||
                item.item_type === productType.toLowerCase())
            : missingAddons.find((item) => item.product_key === productType);
        if (!product && utils.isFlavorBoost(productType)) {
            return {
                image: additionalFlavorSticks,
                title: "Flavor Boosts",
            };
        }
        if (forceFlavor &&
            product &&
            (productType === "hydration" || productType === "preworkout")) {
            setForceFlavor(false);
            const total_count = product.bags_info[0].selected_flavors.reduce((accumulator, object) => accumulator + object.count, 0);
            if (total_count === 0) {
                product.bags_info[0].selected_flavors[0].count = 1;
            }
        }
        return product;
    };
    // const PROTEIN_SKUS = ["og", "ng", "gr", "lr", "om", "nm", "td", "gv", "lv", "pp", "cb", "kb"];
    const removeFromSubscription = async (skuToRemove) => {
        const endpoint = `/api/v2/next-order-cart/`;
        // construct new cart with added item
        let cart = [...userCart].map((item) => ({
            sku: item.sku,
            quantity: item.quantity,
        }));
        // if updating an item's sku, remove old sku
        const itemToRemove = userCart.find((item) => item.sku.toLowerCase() === skuToRemove.toLowerCase());
        if (!itemToRemove) {
            return;
        }
        cart = cart.filter((item) => item.sku.toLowerCase() !== skuToRemove.toLowerCase());
        const proteins = userCart.filter((item) => item.item_type === "protein");
        proteins.forEach((proteinItem) => {
            const flavs = proteinItem.flavors.map((flavor) => ({
                sku: flavor.short_name,
                quantity: 1,
            }));
            cart.push(...flavs);
        });
        // add all existing flavor boosts to cart
        // merge duplicate skus and add quantities together
        const mergedCartItems = cart
            .reduce((acc, cartItem) => {
            const existingCartItem = acc.find((f) => f.sku === cartItem.sku);
            if (existingCartItem) {
                existingCartItem.quantity += cartItem.quantity;
            }
            else {
                acc.push(cartItem);
            }
            return acc;
        }, [])
            .filter((i) => i.quantity);
        await httpService.post(endpoint, { items: mergedCartItems });
        dispatch(setGlobalLoading(true));
        await dispatch(LoadUserCartThunk());
        await dispatch(LoadPricingThunk());
        dispatch(setGlobalLoading(false));
    };
    const onDelete = async (id) => {
        trackDeleteItem(id);
        await removeFromSubscription(id);
        // await dispatch(DeleteUserCartItemThunk({ item_key: id, next_order_only: false }));
    };
    const exploreAll = () => {
        history.push("/app/products/");
    };
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        const product = hash.replace("#", "") || itemType;
        if (reduxUserCart.length > 0 &&
            product &&
            !window.location.pathname.includes("app/products") &&
            !window.location.pathname.includes("/products")) {
            if (!alreadyOpenedDrawer &&
                product &&
                !["modify", "rewards", "future_orders"].includes(product)) {
                setAlreadyOpenedDrawer(true);
                if (product === "hydration" || product === "preworkout") {
                    setForceFlavor(true);
                }
                if (getIsProductIsInCart(product)) {
                    openDrawer(product);
                }
                else {
                    addProductOpenDrawer(product);
                }
            }
        }
    }, [hash, reduxUserCart]);
    const skuToModify = reduxUserCart.find((item) => item.item_type === currentBYBProduct)?.sku;
    const existingFormValues = () => {
        const obj = hydrateValuesFromSku(currentBYBProduct.toUpperCase(), skuToModify);
        if (obj.PROTEIN && !obj.PROTEIN.FLAVORS) {
            const flavorCount = {};
            const flavors = reduxUserCart.find((item) => item.item_type === "protein")?.flavors ||
                [];
            flavors.forEach((item) => {
                const shortName = item.short_name;
                flavorCount[shortName] = (flavorCount[shortName] || 0) + 1;
            });
            obj.PROTEIN.FLAVORS = flavorCount;
        }
        return obj;
    };
    const quantity = findCurrentQuantity(currentBYBProduct);
    const removeBybItem = async () => {
        await onDelete(skuToModify);
        //
        toggleBybDrawer(false)();
    };
    const toExclude = reduxUserCart.map((item) => item.item_type.toLowerCase());
    return {
        getSelectedCurrentProduct,
        findCurrentQuantity,
        currentProduct,
        toggleDrawer,
        onSubmit,
        isMoreDetails,
        isAddProduct,
        reduxUserCart: reduxUserCart.map((item) => ({
            ...item,
            title: isByb
                ? item.title.replace("Personalized", "Customized")
                : item.title,
        })),
        openDrawer,
        isOpen,
        setIsOpen,
        missingAddons,
        addProductOpenDrawer,
        onDelete,
        exploreAll,
        isByb,
        toggleBybDrawer,
        openBybDrawer,
        openEditDrawerBYB,
        currentBYBProduct,
        skuToModify,
        existingFormValues,
        quantity,
        editBybMode,
        removeBybItem,
        toExclude,
    };
};
export default useEditYourBox;
